<template>
  <v-container>
    <h1 class="white--text mb-4">Ausstehende Posts</h1>
    <div v-if="loading" class="text-center py-16">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
    </div>
    <div v-else-if="posts.length === 0" class="text-center white--text py-16">
      <v-icon size="60" class="mb-4">mdi-check-all</v-icon>
      <p>Aktuell gibt es keine Posts zur Freigabe. Sehr gut!</p>
    </div>
    <v-card v-for="(post, index) in posts" :key="post._id" class="mb-4" dark>
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="post.author.bild ? '/img/profilbilder/' + post.author.bild : '/img/profilbilder/uploads/1741100494649.png'"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ post.author.vorname }} {{ post.author.nachname }}</v-list-item-title>
          <v-list-item-subtitle>{{ formatTimestamp(post.createdAt) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- HIER IST DIE KORREKTUR -->
      <v-img v-if="post.content.imageIdentifier" :src="post.imageSrc" height="400" contain>
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>

      <v-card-text v-if="post.content.text" class="mt-4">{{ post.content.text }}</v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="review(post._id, 'rejected', index)">Ablehnen</v-btn>
        <v-btn color="success" depressed @click="review(post._id, 'approved', index)">Genehmigen</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api"
import { formatDistanceToNow } from "date-fns"
import { de } from "date-fns/locale"
import { mapActions, mapState } from "vuex"

export default {
  data() {
    return {
      posts: [],
      loading: true,
    }
  },
  mounted() {
    if (this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  beforeDestroy() {
    if (!this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["toggleNavigationBarVisibility"]),

    async fetchPendingPosts() {
      this.loading = true
      try {
        const pendingPosts = await api.social.getPendingPosts()

        // Promise.all, um alle Bilder parallel und sicher zu laden
        const postsWithImages = await Promise.all(
          pendingPosts.map(async (post) => {
            let imageSrc = null
            if (post.content && post.content.imageIdentifier) {
              try {
                const imageBlob = await api.social.getSecureImage(post.content.imageIdentifier)
                imageSrc = URL.createObjectURL(imageBlob)
              } catch (e) {
                console.error(`Konnte Bild nicht laden für Post ${post._id}`, e)
                // Optional: Fallback-Bild
                imageSrc = "/path/to/error-image.png"
              }
            }
            return { ...post, imageSrc } // Füge die lokale Bild-URL zum Post-Objekt hinzu
          })
        )
        this.posts = postsWithImages
      } catch (error) {
        console.error("Fehler beim Laden der Posts:", error)
      } finally {
        this.loading = false
      }
    },
    async review(postId, status, index) {
      // Deaktiviere die Buttons für diesen Post, um Doppelklicks zu verhindern
      this.$set(this.posts[index], "isReviewing", true)
      try {
        await api.social.reviewPost(postId, status)
        // Post aus der Liste entfernen
        this.posts.splice(index, 1)
      } catch (error) {
        console.error("Fehler beim Prüfen:", error)
        this.$set(this.posts[index], "isReviewing", false)
      }
    },
    formatTimestamp(dateString) {
      if (!dateString) return ""
      return formatDistanceToNow(new Date(dateString), { addSuffix: true, locale: de })
    },
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationVisible"]),
  },
  created() {
    this.fetchPendingPosts()
  },
}
</script>
